import React from "react";
import styled from 'styled-components'
import lottery from '../assets/img/lottery.svg'
const Lottery = props => {
    return (
        <Icon src={lottery} alt='lotteryIcon'/>
    )
};
export default Lottery;

const Icon = styled.img`
    width: 20px;
    height: 20px;
`


// WEBPACK FOOTER //
// ./src/icon/LotteyIcon.js